import React from "react";
import { MDBCol, MDBContainer, MDBRow, MDBFooter } from "mdbreact";

const Footer = () => {
  return (
    <MDBFooter color="rgba-blue-grey-strong" dark>
      <div className="footer-copyright text-center py-3">
        <MDBContainer fluid>
          &copy; {new Date().getFullYear()} Copyright: You Know Who
        </MDBContainer>
      </div>
      {/* <GoogleMap/> */}
    </MDBFooter>
  );
};

export default Footer;
